/*
* DatagridCalculatedRowUpdater component specific for Adalia M&E.
*/

import React from 'react';
import update from 'immutability-helper';

import { fetchJson } from '../../../../helpers/fetch.js';
import {FormContext} from '../../form_context.jsx';

import {
    GridLayout,
    DropdownSelectionWithAsyncOptions,
    Resolver
} from '../../form_components.jsx';
import {resolveComponentProps} from '../../form_viewer.jsx';

import Setting from '../setting.jsx'
import Helpers from '../helpers.jsx';
import { DataType, Mode } from '../../common.jsx';


import Select from '../../../common/Select.jsx';

import {
  datagrid_results_as_per_preset_path
} from '~/routes';

export default class AdaliaMeDatagridCalculatedRowUpdater extends GridLayout {

  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'adalia_me_datagrid_calculated_row_updater';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_datagrid_calculated_row_updater',
      description: 'field_default_description',
      help: null,
      blankOptionLabel: 'select_blank_option_default'
    };
  }

  static icon() {
    return <i className='fa fa-calculator'></i>;
  }

  constructor(props) {
    super(props);
    this.addRow = this.addRow.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.addColumn = this.addColumn.bind(this);
    this.deleteColumn = this.deleteColumn.bind(this);
    this.reorderOption = this.reorderOption.bind(this);
    this.handleSelectedGroupKeysChanged = this.handleSelectedGroupKeysChanged.bind(this);

    this.state = {
      loading: false,
      answers: props.answers || {},
      selectedGroupKeys: {}
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      level: 'project',
      name: 'datagrid_calculated_row_updater_' + Helpers.randomString(),
      rows: [
        [{span: 1, component: Object.assign(AdaliaMeDatagridCalculatedRowSelectorGridLayout.defaultContent(language), {})}],
        [{span: 1, component: Object.assign(AdaliaMeDatagridCalculatedRowGridLayout.defaultContent(language), {})}]
      ]
    });
  }

  componentDidMount() {
    super.componentDidMount();

    if (typeof this.props.updateSettingsCallback == 'function') {
      let dgRowSelector = Object.assign(AdaliaMeDatagridCalculatedRowSelectorGridLayout.defaultContent(this.props.language), {});
      let maxLevels = this.props.content.rowGroupCols.length;

      let content = update(this.props.content, {
        rows: {
          [0]: {
            [0]: {
              ['component']:  (obj) =>
                update(obj || {}, {
                  $merge: Object.assign(dgRowSelector, {
                    datagridId: this.props.content.datagridId,
                    rows: this.props.content.rowGroupCols.map((col, level) =>
                      [{
                         span: 1,
                         component: Object.assign(AdaliaMeDatagridCalculatedRowSelector.defaultContent(this.props.language), {
                           level: level,
                           maxLevels: maxLevels,
                           groupCol: col,
                           datagridId: this.props.content.datagridId,
                           presetId: this.props.content.presetId,
                           selectedGroupKeys: Object.values(this.state.selectedGroupKeys).slice(0, level).filter((k) => k != ''),
                           handleSelectedGroupKeysChanged: this.handleSelectedGroupKeysChanged,
                           name: `${dgRowSelector.name}_selector_${level}`,
                           translations: {[this.props.language]: {
                             label: `${col.name}`,
                             description: '',
                             placeholder: ''
                           }}
                         })
                      }]
                    )
                  })
                })
              }
          },
          [1]: {
            [0]: {$merge: Object.assign(this.props.content.rows[1][0].component, {datagridId: this.props.content.datagridId})}
          }
        }
      });

      this.props.updateSettingsCallback(content.id, content);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate();
  }

  handleSelectedGroupKeysChanged = (levelIndex, value) => {
    this.setState((prevState) => {
      const updatedLevels = { ...prevState.selectedGroupKeys };

      // Set the value for the specific level
      updatedLevels[levelIndex] = value;

      // Reset subsequent levels to blank
      for (let i = levelIndex + 1; i < Object.keys(updatedLevels).length; i++) {
        updatedLevels[i] = '';
      }

      return { selectedGroupKeys: updatedLevels, loading: true };
    }, () => {this.setState({loading: false})});
  };

  answersChanged = (answers) => {
    this.setState({loading: true});
    let newAnswers = this.mappingNewAnswers(answers);

    this.setState(prevState => ({answers: { ...prevState.answers, ...newAnswers}, loading: false}));
  };

  extractReportKeys = (obj) => {
    let reportKeys = {};

    const traverse = (node) => {
      // Check if the current node has a reportKey property
      if (node?.hasOwnProperty('reportKey')) {
        reportKeys[node.reportKey] = node.name;
      }

      // If the current node is an object, loop through its keys
      for (let key in node) {
        if (node?.hasOwnProperty(key) && typeof node[key] === 'object') {
          // Recursive call for nested objects/arrays
          traverse(node[key]);
        }
      }
    };

    // Start the traversal from the root object
    traverse(obj);

    return reportKeys;
  };

  mappingNewAnswers = (answers) => {
    var result = {};
    var content = this.extractReportKeys(this.props.content);

    for (var key in content) {
      var field = content[key];
      if (answers[key] !== undefined) {
        result[field] = answers ? answers[key] : '';
      }
    }

    if (this.props.repeatedFieldScope) {
      // Step 1: Extract the main field name and the nested key
      var match = this.props.repeatedFieldScope.match(/^(.*?)\[(.*?)\]$/);

      if (match) {
        let mainField = match[1];
        let nestedField = match[2];

        // Step 2: Construct the nested object structure
        return {
          [mainField]: {
            [nestedField]: result
          }
        };
      }
    }

    return result;
  };

  renderView() {
    const lookupComponent = Resolver.createElement(AdaliaMeDatagridCalculatedRowSelectorGridLayout.TYPE,
      resolveComponentProps(this.props.content.rows[0][0].component, this.props, {
        swapComponentsOnDrop: false,
        selectCallback: this.props.selectCallback,
        selectedId: this.props.selectedId,
        deleteRepeatableRegionAnswerCallback: this.props.deleteRepeatableRegionAnswerCallback,
        fieldScope: this.props.fieldScope,
        repeatedFieldScope: this.props.repeatedFieldScope,
        datagridId: this.props.content.datagridId,
        answersChanged: this.answersChanged,
        selectedGroupKeys: Object.values(this.state.selectedGroupKeys).filter((k) => k != ''),
        handleSelectedGroupKeysChanged: this.handleSelectedGroupKeysChanged
      }));


      const gridLayoutComponent = Resolver.createElement(AdaliaMeDatagridCalculatedRowGridLayout.TYPE,
      resolveComponentProps(this.props.content.rows[1][0].component, {...this.props, answers: this.state.answers, readOnly: true}, {
        swapComponentsOnDrop: true,
        selectCallback: this.props.selectCallback,
        selectedId: this.props.selectedId,
        deleteRepeatableRegionAnswerCallback: this.props.deleteRepeatableRegionAnswerCallback,
        fieldScope: this.props.fieldScope,
        repeatedFieldScope: this.props.repeatedFieldScope,
        datagridId: this.props.content.datagridId,
        ...this.componentProps(this.props.content.rows[1][0].component),
        answers: this.state.answers
    }));

    const components =
      <div
        style={{
          backgroundColor: '#8880800a',
          border: '1px solid #00000033',
          borderRadius: '5px',
          boxShadow: '0 0 10px #00000033',
          padding: '0 15px'
        }}
        className='grid_layout'
      >
        {gridLayoutComponent}
      </div>;

    return (
      <div>
        {lookupComponent}
        {this.state.loading ? <></> : components}
      </div>
    );
  }

  renderSettings() {
    return <></>
  }
}

export class AdaliaMeDatagridCalculatedRowSelectorGridLayout extends GridLayout {

    constructor(props) {
        super(props);
        this.addRow = this.addRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.addColumn = this.addColumn.bind(this);
        this.deleteColumn = this.deleteColumn.bind(this);
        this.reorderOption = this.reorderOption.bind(this);
    }

  static get TYPE() {
    return 'adalia_me_datagrid_calculated_row_selector_grid_layout';
  }

  static defaultContent(language) {
    var fieldName = `field_${Helpers.randomString()}`;

    return Object.assign(super.defaultContent(language), {
      name: fieldName,
      deletable: false,
      sortable: false
    });
  }

  static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
    if (droppedContent.datagridId && targetContent.datagridId != droppedContent.datagridId && targetContent.id == dropArea.getAttribute('data-component-id')) {
      alert(I18n.t('component_belongs_to_another_data_grid', {scope: 'fe'}));
      return false;
    }

    if (AdaliaMeDatagridCalculatedRowSelector.TYPE != droppedContent.type) {
      return false;
    }

    return super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
  }

  componentProps(_) {
    return { selectedGroupKeys: this.props.selectedGroupKeys, handleSelectedGroupKeysChanged:  this.props.handleSelectedGroupKeysChanged, answersChanged: this.props.answersChanged };
  }
}

export class AdaliaMeDatagridCalculatedRowSelector extends DropdownSelectionWithAsyncOptions {
  static contextType = FormContext;

  static get TYPE() {
    return 'adalia_me_datagrid_calculated_row_selector';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_datagrid_calculated_row_updater',
      description: 'field_default_description',
      help: null,
      blankOptionLabel: 'select_blank_option_default'
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      deletable: true,
      sortable: true,
      allowMultiple: false,
      cloneable: false,
      dataType: DataType.STRING,
      reportKey: '',
      includeBlank: true,
      blankOptionLabel: 'blankOptionLabel'
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      groupKeys: {},
      rowGroupCols: [],
      rows: {},
      options: [],
      selectedGroupKeys: this.props.selectedGroupKeys,
      calculatedData: {}
    }
  }

  componentDidMount() {
    super.componentDidMount();

    let projectId = this.context.projectId || jQuery('#report-container').data('project-id');

    if (projectId && this.props.mode == Mode.FILL) {
      if (this.props.content.level == 0 && this.state.options.length == 0) {
        this.setState({loading: true});

        fetchOptionsForSelect(
          this.props.content.datagridId,
          this.props.content.presetId,
          projectId,
          this.context.programmeFormId,
          this.state.selectedGroupKeys.slice(0, this.props.content.level),
          this.getAnswer(),
          this.props.handleDisbursement,
          (res) => {
            if (res) {
              this.setState({
                options: this.getFormattedOptions(res.rows, this.props.content.groupCol),
                calculatedData: res.calculatedData,
                loading: false
              });
            }
          });
      }
    }
  }

  componentDidUpdate() {
    //super.componentDidUpdate();

    let projectId = this.context.projectId || jQuery('#report-container').data('project-id');

    if (projectId && this.props.content.level > 0) {
      if (
        (this.props.selectedGroupKeys.length > 0) &&
        (this.props.selectedGroupKeys.length >= this.props.content.level || this.state.selectedGroupKeys.length >= this.props.content.level) &&
        (
          (this.props.content.level == this.props.content.maxLevels -1 && this.props.selectedGroupKeys != this.state.selectedGroupKeys) ||
          (this.state.selectedGroupKeys[this.props.content.level - 1] == undefined && this.props.selectedGroupKeys[this.props.content.level - 1] != undefined) ||
          (this.state.selectedGroupKeys[this.props.content.level - 1] != undefined && this.props.selectedGroupKeys[this.props.content.level - 1] != undefined && this.props.selectedGroupKeys[this.props.content.level - 1] != this.state.selectedGroupKeys[this.props.content.level - 1])
        )
      ) {
        if (this.props.content.level != this.props.content.maxLevels -1 || this.props.selectedGroupKeys.length == this.props.content.level)
          this.setState({loading: true});

        fetchOptionsForSelect(
          this.props.content.datagridId,
          this.props.content.presetId,
          projectId,
          this.context.programmeFormId,
          this.props.selectedGroupKeys,
          this.getAnswer(),
          this.props.handleDisbursement,
          (res) => {
            if (res) {
              this.setState({
                options: this.getFormattedOptions(res.rows, this.props.content.groupCol),
                selectedGroupKeys: this.props.selectedGroupKeys,
                calculatedData: res.calculatedData,
                loading: false
              });

              this.props.answersChanged(res.calculatedData);
            }
        });

      } else if (this.state.options.length > 0 && this.props.selectedGroupKeys[this.props.content.level -1] == undefined)
        this.setState({options: [], selectedGroupKeys: this.props.selectedGroupKeys})
    }
  }

  getFormattedOptions(rows, col) {
    return (rows || []).map(row => _.isObject(row[col.id]) ? {value: row[col.id].id, label: row[col.id].label} : {value: row[col.id], label: row[col.id]})
  }

  onChange = (value) => {
    this.updateAnswer(value);

    let selectedGroupKeys = [...this.state.selectedGroupKeys];
    selectedGroupKeys[this.props.content.level] = value;

    this.setState({selectedGroupKeys: selectedGroupKeys.filter((k) => k != '')});
    this.props.handleSelectedGroupKeysChanged(this.props.content.level, value);
  };

  static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = '') {
    let labels = [];
    if (content.name) {
      labels.push(repeatedFieldScope + "[" + content.name + "_label]");
    }

    return [...(super.resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope) || []), ...labels];
  }

  renderOptions() {
    if (this.state.loading) {
      return this.renderOptionsLoading();
    }

    var selected = this.props.mode == Mode.FILL ? this.getSelected() : this.getAnswer();
    selected = `${Array.isArray(selected) ? selected[0] : selected}`;

    var options = this.props.mode == Mode.FILL ? (
      this.getOptions().map((o, i) => {
        return {...o, label: o.label, value: o.value, disabled: o.disabled}
      })
    ) : [{label: this.answerSavedAsLabel(), value: selected}];

    if (this.props.content.includeBlank) {
      options.unshift({label: this.getText('blankOptionLabel'), value: '' })
    }

    var dynamicProps = {};
    if (typeof this.formatOptionLabel == 'function') {
      dynamicProps.formatOptionLabel = this.formatOptionLabel;
    }

    return (
      <div key='loaded'>
        {<input type='hidden' name={this.fullFieldName(false)} value={selected}/>}
        {<input type='hidden' name={this.fullFieldName(false, '_label')} value={this.getFlatOptions().find((v) => v.value==selected)?.label}/>}

        <Select
          key={options.length}
          value={selected}
          autoComplete={this.getAutoComplete()}
          readOnly={this.props.mode != Mode.FILL}
          disabled={(this.props.mode == Mode.FILL && this.isReadOnlyAnswer()) || this.props.disabled || this.props.mode == Mode.VIEW}
          onChange={this.onChange}
          className={`${this.isReadOnlyAnswer() ? 'locked' : ''}`}
          options={options}
          isMulti={false}
          styles={this.props.content.disableSingleRemove ? {
            multiValueRemove: (provided, state) => ({
              ...provided,
              display: 'none'
            })} : {}}
          {...dynamicProps}
        />
      </div>
    );
  }

  answerSavedAsLabel() {
    let fieldNamePath = this.fullFieldName(false, '_label').split(/[\[\]]+/).filter((s) => (['', this.props.fieldScope].indexOf(s) == -1));
    return Helpers.getObjectValue(this.props.answers || {}, fieldNamePath) || '';
  }

  renderSettings() {
    return <div>
      <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name='label_hidden' className='label-hidden-check' label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name='description' label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name='help' label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField name='blankOptionLabel' label={I18n.t('select_blank_option_label', {scope: 'fe'})} value={this.getText('blankOptionLabel')} onChange={this.updateSettings} />
    </div>
  }

  beforeUpdateSettings(content) {
    super.beforeUpdateSettings(content);
  }
}

export class AdaliaMeDatagridCalculatedRowGridLayout extends GridLayout {

  static get TYPE() {
    return 'adalia_me_datagrid_calculated_row_grid_layout';
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      deletable: false,
      sortable: false,
      rows: [
        [{span: 1, component: null}]
      ]
    });
  }

  static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
    if (droppedContent.datagridId && targetContent.datagridId != droppedContent.datagridId && targetContent.id == dropArea.getAttribute('data-component-id')) {
      alert(I18n.t('component_belongs_to_another_data_grid', {scope: 'fe'}));
      return false;
    }

    if ([AdaliaMeDatagridCalculatedRowUpdater.TYPE, AdaliaMeDatagridCalculatedRowSelector.TYPE].includes(droppedContent.type))
      return false;

    if (droppedContent.datagridId && !droppedContent.name.includes('datagrid_calculated_row')) {
      let name = `datagrid_calculated_row-${droppedContent.datagridId}-${droppedContent.name}`;
      if (droppedContent.rows && droppedContent.rows[0])
        droppedContent.rows[0][0].component.name = name;
      else
        droppedContent.name = name;
    }

    return super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
  }

  getAnswerByComponentName = (data, key) => {
    // Split the key into parts
    const parts = key.split(/[\[\]]/).filter(part => part);

    let value = data;

    for (let part of parts) {
      if (value[part] !== undefined) {
        value = value[part];
      } else {
        return undefined;
      }
    }

    return value;
  };

  renderView() {
    let rows = this.props.content.rows.map((row, rowIdx) => {
      let cols = row.map((col, colIdx) => {
        let component = null;

        if (col.component) {
          component = Resolver.createElement(col.component.type,
            resolveComponentProps(col.component, this.props, {
              swapComponentsOnDrop: true,
              selectCallback: this.props.selectCallback,
              selectedId: this.props.selectedId,
              deleteRepeatableRegionAnswerCallback: this.props.deleteRepeatableRegionAnswerCallback,
              fieldScope: this.props.fieldScope,
              repeatedFieldScope: this.props.repeatedFieldScope,
              datagridId: this.props.datagridId,
              ...this.componentProps(col.component),
              answers: this.props.answers
            })
          );

          this.props.findComponentsCallback({dataType: [DataType.INTEGER, DataType.DECIMAL, DataType.DATE, DataType.STRING]}).filter((v) => v.sourcesOfPrefill).forEach((c) => {
            if (typeof this.props.updateAnswerCallback == 'function') {
              var componentvalue = '';
              var componentName = c.name;

              if (component.props.repeatedFieldScope) {
                componentName = `${component.props.repeatedFieldScope}[${c.name}]`;
                componentvalue = this.getAnswerByComponentName(this.props.answers, `${component.props.repeatedFieldScope}[${c.sourcesOfPrefill}]`);
              } else {
                componentvalue = this.props.answers[c.sourcesOfPrefill];
              }

              if (componentvalue !== undefined) {
                setTimeout(() => this.props.updateAnswerCallback(`${component.props.fieldScope}[${componentName}]`, componentvalue), 50);
              }
            }
          });

        } else if (this.inEditMode) {
          component = (<Helpers.DropArea componentId={this.props.content.id} context={rowIdx + '-' + colIdx} />);
        }
        return (
          <div
            key={colIdx}
            className={`grid-col ${this.renderComponentCol(component) ? '' : 'd-none'}`}
            style={this.props.asWebView ? {flex: col.span, flexBasis: 'min-content', overflowX: 'auto'} : {flex: col.span}}
            data-flex={col.span}
          >
            {component}
          </div>
        );
      });

      return (
        <div key={rowIdx} className="grid-row" style={this.props.asWebView ? {flexWrap: 'wrap'} : null}>
          {cols}
        </div>
      );
    });

    return (
      <div className='wrapper'>
        {rows}
      </div>
    );
  }
}

const fetchOptionsForSelect = (datagrid_id, preset_id, project_id, programme_form_id, groupKeys, selected, handlingEnabled, cb) => {
  fetchJson(datagrid_results_as_per_preset_path({id: datagrid_id, datagrid_preset_id: preset_id, project_id: project_id, programme_form_id: programme_form_id, groupKeys: groupKeys, _options: true})).then(
    (res) => {
        cb(res);
    }
  )
};
